function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import { css } from "styled-components";
import Colr from "colr";
import common, { spacing } from "../../common";
export var hoverColor = function hoverColor(color) {
  return Colr.fromHex(color).darken(10).toHex();
};
export var activeColor = function activeColor(color) {
  return Colr.fromHex(color).darken(20).toHex();
};
export var disabledColor = function disabledColor(color, percent) {
  var opacity = percent || 0.3;
  var rgb = Colr.fromHex(color).toRgbArray().toString();
  return "rgba(".concat(rgb, ", ").concat(opacity, ")");
};
var typeScale = {
  1: "3.125rem",
  2: "2.5rem",
  3: "1.875rem",
  4: "1.6875rem",
  5: "1.5rem",
  6: "1.40625rem",
  7: "1.25rem",
  8: "1.125rem",
  9: "1rem",
  10: ".9375rem",
  11: ".875rem",
  12: ".8125rem",
  13: ".75rem",
  14: ".65rem"
};
var lineHeights = [1.5625, 1.4666666667, 1.375, 1.3333333333, 1.2, 1.1, 1];
var tracking = {
  normal: "normal",
  paragraph: "-0.25px",
  heading: "-0.5px"
};
var fonts = {
  plutoSans: "\"Pluto Sans\", Arial, Helvetica, sans-serif",
  serif: "\"Georgia\", \"Times New Roman\", serif"
};
var colors = {
  brand: {
    base: "#80c342",
    light: "#c1e2a3",
    dark: "#afd88e"
  },
  accent: "#F7931E",
  shades: {
    black: "#222222",
    darkest: "#303d46",
    darker: "#525354",
    dark: "#666666",
    light: "#aaacae",
    lighter: "#e1e1e1",
    lightest: "#f7f7f7",
    nearWhite: "#fafafa",
    white: "#ffffff"
  },
  focus: "#c1e2a3",
  success: "#80c342",
  error: "#af0f21",
  info: "#005bb9",
  product: {
    hospital: "#303E46",
    extras: "#303E46",
    combined: "#303E46",
    highlight: {
      backgroundColor: "#4dc731",
      textColor: "#182225"
    }
  }
};
var focus = {
  outlineColor: colors.focus,
  outlineStyle: "solid",
  outlineWidth: "2px",
  outlineOffset: "0.125em"
};
var baseButtonStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: middle;\n  text-transform: uppercase;\n  font-family: 'Pluto Sans', Arial, Helvetica, sans-serif;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0.1em;\n  text-align: center;\n  text-wrap: balance;\n  text-decoration: none;\n  cursor: pointer;\n  border-radius: 3px;\n  transition-property: background, border-color, color;\n  transition-duration: 150ms;\n  outline: 0;\n\n  &:hover {\n  }\n\n  &:active {\n  }\n\n  &:disabled {\n    background: #cacbcc;\n    color: ", ";\n    border: solid 1px #cacbcc;\n  }\n\n  &:focus {\n    outline-width: ", ";\n    outline-style: ", ";\n    outline-color: ", ";\n    outline-offset: ", ";\n  }\n"])), colors.shades.darker, focus.outlineWidth, focus.outlineStyle, focus.outlineColor, focus.outlineOffset);
var buttonStyles = {
  primary: {
    "default": {
      normal: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n        background: ", ";\n        color: #1b2225;\n        border: solid 1px ", ";\n\n        &:hover {\n          background: ", ";\n          border: solid 1px ", ";\n          color: #1b2225;\n        }\n\n        &:active {\n          background: ", ";\n          color: #1b2225;\n          border: solid 1px ", ";\n        }\n\n        &:disabled {\n          background: #cacbcc;\n          color: ", ";\n          border: solid 1px #cacbcc;\n        }\n      "])), baseButtonStyles, colors.brand.base, colors.brand.base, colors.brand.light, colors.brand.light, colors.brand.base, colors.brand.base, colors.shades.darker),
      selected: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        background: #1b2225;\n        color: ", ";\n        border: solid 1px #1b2225;\n      "])), colors.brand.base),
      disabled: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        background: #cacbcc;\n        color: ", ";\n        border: solid 1px #cacbcc;\n      "])), colors.shades.darker)
    },
    destructive: {
      normal: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        ", "\n        background: ", ";\n        color: ", ";\n        border: solid 1px ", ";\n\n        &:hover {\n          background: ", ";\n          border: solid 1px ", ";\n        }\n\n        &:active {\n          background: ", ";\n          border: solid 1px ", ";\n        }\n\n        &:disabled {\n          background: #cacbcc;\n          color: ", ";\n          border: solid 1px #cacbcc;\n        }\n      "])), baseButtonStyles, colors.error, colors.shades.white, colors.error, hoverColor(colors.error), hoverColor(colors.error), activeColor(colors.error), activeColor(colors.error), colors.shades.darker),
      selected: css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        background: ", ";\n        border: solid 1px ", ";\n      "])), activeColor(colors.error), activeColor(colors.error)),
      disabled: css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        background: #cacbcc;\n        color: ", ";\n        border: solid 1px #cacbcc;\n      "])), colors.shades.darker)
    }
  },
  secondary: {
    "default": {
      normal: css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        ", "\n        background: transparent;\n        border: solid 1px ", ";\n        color: #000;\n\n        &:hover {\n          background: ", ";\n          border: solid 1px ", ";\n          color: #1b2225;\n        }\n\n        &:active {\n          background: ", ";\n          color: #1b2225;\n          border: solid 1px ", ";\n        }\n\n        &:disabled {\n          background: #cacbcc;\n          color: ", ";\n          border: solid 1px #cacbcc;\n        }\n      "])), baseButtonStyles, colors.brand.base, colors.brand.light, colors.brand.base, colors.brand.base, colors.brand.base, colors.shades.darker),
      selected: css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        background: ", ";\n        color: #1b2225;\n        border: solid 1px ", ";\n\n        &:hover {\n          background: ", ";\n          border: solid 1px ", ";\n          color: #1b2225;\n        }\n      "])), colors.brand.base, colors.brand.base, colors.brand.light, colors.brand.base),
      disabled: css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        background: #cacbcc;\n        color: ", ";\n        border: solid 1px #cacbcc;\n      "])), colors.shades.darker)
    },
    destructive: {
      normal: css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        ", "\n        background: transparent;\n        border: solid 1px ", ";\n        color: ", ";\n\n        &:hover {\n          background: #efcfd3;\n          border: solid 1px ", ";\n        }\n\n        &:active {\n          color: ", ";\n          background: ", ";\n          border: solid 1px ", ";\n        }\n\n        &:disabled {\n          background: #cacbcc;\n          color: ", ";\n          border: solid 1px #cacbcc;\n        }\n      "])), baseButtonStyles, colors.error, colors.error, hoverColor(colors.error), colors.shades.white, colors.error, colors.error, colors.shades.darker),
      selected: css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        color: ", ";\n        background: ", ";\n        border: solid 1px ", ";\n\n        &:hover {\n          background: #efcfd3;\n          border: solid 1px ", ";\n        }\n      "])), colors.shades.white, colors.error, colors.error, hoverColor(colors.error)),
      disabled: css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n        background: #cacbcc;\n        color: ", ";\n        border: solid 1px #cacbcc;\n      "])), colors.shades.darker)
    }
  },
  tertiary: {
    "default": {
      normal: css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        ", "\n        background: none;\n        border: none;\n        color: #000;\n\n        &:hover {\n          background: ", ";\n          color: #1b2225;\n        }\n\n        &:active {\n          background: ", ";\n          color: #1b2225;\n        }\n\n        &:disabled {\n          background: #cacbcc;\n          color: ", ";\n        }\n      "])), baseButtonStyles, colors.brand.light, colors.brand.base, colors.shades.darker),
      selected: css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n        background: ", ";\n        color: #1b2225;\n\n        &:hover {\n          background: ", ";\n          color: #1b2225;\n        }\n      "])), colors.brand.base, colors.brand.light),
      disabled: css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n        background: #cacbcc;\n        color: ", ";\n      "])), colors.shades.darker)
    },
    destructive: {
      normal: css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n        ", "\n        background: none;\n        border: none;\n        color: ", ";\n\n        &:hover {\n          background: #efcfd3;\n        }\n\n        &:active {\n          color: ", ";\n          background: ", ";\n        }\n\n        &:disabled {\n          background: #cacbcc;\n          color: ", ";\n        }\n      "])), baseButtonStyles, colors.error, colors.shades.white, colors.error, colors.shades.darker),
      selected: css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n        color: ", ";\n        background: ", ";\n\n        &:hover {\n          background: #efcfd3;\n        }\n      "])), colors.shades.white, colors.error),
      disabled: css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n        background: #cacbcc;\n        color: ", ";\n      "])), colors.shades.darker)
    }
  },
  small: css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    padding: ", ";\n    font-size: ", ";\n  "])), spacing[3], typeScale[14]),
  medium: css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    padding: ", ";\n    font-size: ", ";\n  "])), spacing[4], typeScale[13]),
  large: css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n    font-size: ", ";\n  "])), spacing[4], spacing[6], typeScale[12])
};
var baseFormValues = {
  borderColor: colors.shades.dark,
  borderColorValid: colors.success,
  borderColorInvalid: colors.error,
  selectedToggleColor: colors.brand.base,
  helpTextColor: colors.shades.dark,
  helpTextSize: typeScale[11],
  labelColor: colors.shades.dark,
  labelSize: typeScale[10],
  errorMessageTextColor: colors.error,
  infoMessageTextColor: colors.info
};
var tal = _objectSpread(_objectSpread({}, common), {}, {
  typeScale: typeScale,
  fonts: fonts,
  colors: colors,
  focus: focus,
  id: "tal",
  mode: {
    form: "light" //default
  },
  headings: {
    color: colors.shades.black,
    h1: {
      fontFamily: fonts.plutoSans,
      fontSize: typeScale[3],
      lineHeight: lineHeights[5],
      fontWeight: 700,
      tracking: tracking.heading,
      uppercase: false
    },
    h2: {
      fontFamily: fonts.plutoSans,
      fontSize: typeScale[6],
      lineHeight: lineHeights[3],
      fontWeight: 700,
      tracking: tracking.heading,
      uppercase: false
    },
    h3: {
      fontFamily: fonts.plutoSans,
      fontSize: typeScale[8],
      lineHeight: lineHeights[4],
      fontWeight: 700,
      tracking: tracking.heading,
      uppercase: false
    },
    h4: {
      fontFamily: fonts.plutoSans,
      fontSize: typeScale[9],
      lineHeight: lineHeights[4],
      fontWeight: 700,
      tracking: tracking.heading,
      uppercase: false
    },
    h5: {
      fontFamily: fonts.plutoSans,
      fontSize: typeScale[13],
      lineHeight: lineHeights[0],
      fontWeight: 700,
      tracking: tracking.heading,
      uppercase: false
    },
    h6: {
      fontFamily: fonts.plutoSans,
      fontSize: typeScale[9],
      lineHeight: lineHeights[0],
      fontWeight: 700,
      tracking: tracking.heading,
      uppercase: false
    }
  },
  copy: {
    color: colors.shades.dark,
    fontFamily: fonts.plutoSans,
    fontSize: typeScale[10],
    fontWeight: 400,
    lineHeight: lineHeights[0],
    smallFontSize: typeScale[11],
    largeFontSize: typeScale[8]
  },
  link: {
    loudColor: colors.brand.base,
    darkColor: colors.shades.black,
    lightColor: colors.shades.white,
    destructiveColor: colors.error
  },
  button: {
    small: buttonStyles.small,
    medium: buttonStyles.medium,
    large: buttonStyles.large,
    primary: {
      dark: buttonStyles.primary["default"],
      light: buttonStyles.primary["default"],
      destructive: buttonStyles.primary.destructive
    },
    secondary: {
      dark: buttonStyles.secondary["default"],
      light: buttonStyles.secondary["default"],
      destructive: buttonStyles.secondary.destructive
    },
    tertiary: {
      dark: buttonStyles.tertiary["default"],
      light: buttonStyles.tertiary["default"],
      destructive: buttonStyles.tertiary.destructive
    }
  },
  forms: {
    light: _objectSpread(_objectSpread({}, baseFormValues), {}, {
      backgroundColor: colors.shades.lightest,
      inputBackgroundColor: colors.shades.white,
      boxShadow: "0 4px 8px 0 ".concat(colors.shades.lighter)
    }),
    white: _objectSpread(_objectSpread({}, baseFormValues), {}, {
      backgroundColor: colors.shades.white,
      inputBackgroundColor: colors.shades.lightest,
      boxShadow: "none"
    })
  },
  smallFooter: {
    backgroundColor: colors.shades.darkest,
    textColor: colors.shades.lightest,
    linkColor: colors.shades.lightest
  },
  panel: {
    loud: {
      backgroundColor: colors.brand.base,
      textColor: colors.shades.white
    },
    muted: {
      backgroundColor: colors.shades.lighter,
      textColor: colors.shades.darkest
    },
    light: {
      backgroundColor: colors.shades.lightest,
      textColor: colors.shades.darkest
    },
    dark: {
      backgroundColor: colors.shades.darkest,
      textColor: colors.shades.white
    },
    white: {
      backgroundColor: colors.shades.white,
      textColor: colors.shades.darkest
    }
  }
});
export default tal;